module.exports = {
  imgbb_API_KEY: "e25123029e452dde1d196979742ce36c",
};
